import React from 'react';
import PropTypes from 'prop-types';

class Login extends React.Component{

    login = (e) => {
        e.preventDefault();
        const username = this.username.value;
        const password = this.password.value;
        this.props.login(username, password);
    };

    render() {
        return (
            <div className="loginForm">
                <h3>Login</h3>
                <p>Sign in to access the admin panel for intuitive-sensitives.com</p>
                <form onSubmit={e => this.login(e)}>
                    <input type="text" ref={input => this.username = input} placeholder="Email"/>
                    <input type="password" ref={input => this.password = input} placeholder="Password"/>
                    <button type="submit" className="btn btn-primary btn-right">Login</button>
                </form>
            </div>
        );
    }
}

Login.propTypes = {
    login: PropTypes.func.isRequired
}

export default Login;


/** WEBPACK FOOTER **
 ** ./src/components/Login.js
 **/